import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner, Row, Col, Alert } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../../utils/httpProvider';
import { KETQUATUYENSINH_API, CHITIETKETQUANCS_API } from '../../../../../utils/apiUrl';
import { objectKetQuaTuyenSinh, ketQuaTuyenSinhValue, objectThoiHanDaoTao } from '../../../../../utils/define';
import DocumentInput from '../../../../../components/document-input/DocumentInput';

const KetQuaTuyenSinhTab = ({ hoSoId, deCuongId }) => {
    const [formData, setFormData] = useState({
        id: null,
        hoSoTuyenSinhId: hoSoId,
        ketQua: ketQuaTuyenSinhValue.trungTuyen,
        diemXetTuyen: 0,
        soQuyetDinh: '',
        canBoHuongDan: '',
        thoiHanDaoTao: null,
        tuNgay: '',
        denNgay: '',
        fileQuyetDinh: ''
    });
    const [saving, setSaving] = useState(false);

    // Fetch existing KetQuaTuyenSinh
    const { data: ketQuaRes, isLoading, refetch } = useQuery(
        ['ketQuaTuyenSinhData', hoSoId],
        () => Get(KETQUATUYENSINH_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1, HoSoTuyenSinhId: hoSoId }),
        { enabled: !!hoSoId }
    );

    useEffect(() => {
        if (ketQuaRes && ketQuaRes.data) {
            let items = [];
            if (Array.isArray(ketQuaRes.data)) items = ketQuaRes.data;
            else if (Array.isArray(ketQuaRes.data.data)) items = ketQuaRes.data.data;
            else if (Array.isArray(ketQuaRes.data.$values)) items = ketQuaRes.data.$values;
            
            if (items.length > 0) {
                const item = items[0];
                const rawKetQua = item.ketQua !== undefined ? item.ketQua : item.KetQua;
                let parsedKetQua = ketQuaTuyenSinhValue.khongTrungTuyen;
                if (rawKetQua === 0 || String(rawKetQua) === '0' || String(rawKetQua).toLowerCase() === 'trungtuyen') {
                    parsedKetQua = ketQuaTuyenSinhValue.trungTuyen;
                } else if (rawKetQua === 1 || String(rawKetQua) === '1' || String(rawKetQua).toLowerCase() === 'khongtrungtuyen') {
                    parsedKetQua = ketQuaTuyenSinhValue.khongTrungTuyen;
                } else if (rawKetQua === 2 || String(rawKetQua) === '2' || String(rawKetQua).toLowerCase() === 'trungtuyencanbosung') {
                    parsedKetQua = ketQuaTuyenSinhValue.trungTuyenCanBoSung;
                }

                setFormData(prev => ({
                    ...prev,
                    id: item.id || item.Id,
                    hoSoTuyenSinhId: item.hoSoTuyenSinhId || item.HoSoTuyenSinhId,
                    ketQua: parsedKetQua,
                    diemXetTuyen: prev.diemXetTuyen > 0 ? prev.diemXetTuyen : (item.diemXetTuyen !== undefined ? item.diemXetTuyen : item.DiemXetTuyen),
                    soQuyetDinh: item.soQuyetDinh || item.SoQuyetDinh || '',
                    canBoHuongDan: item.canBoHuongDan || item.CanBoHuongDan || '',
                    thoiHanDaoTao: item.thoiHanDaoTao !== undefined ? item.thoiHanDaoTao : (item.ThoiHanDaoTao !== undefined ? item.ThoiHanDaoTao : null),
                    tuNgay: item.tuNgay ? item.tuNgay.split('T')[0] : (item.TuNgay ? item.TuNgay.split('T')[0] : ''),
                    denNgay: item.denNgay ? item.denNgay.split('T')[0] : (item.DenNgay ? item.DenNgay.split('T')[0] : ''),
                    fileQuyetDinh: item.fileQuyetDinh || item.FileQuyetDinh || ''
                }));
            }
        }
    }, [ketQuaRes]);

    // Fetch real-time score from ChiTietKetQuaNCS
    const { data: chiTietRes } = useQuery(
        ['chiTietKetQuaNCS_ForKetQua', deCuongId],
        () => Get(CHITIETKETQUANCS_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1000, DeCuongNghienCuuId: deCuongId }),
        { enabled: !!deCuongId }
    );

    useEffect(() => {
        if (chiTietRes && chiTietRes.data) {
            let items = [];
            if (Array.isArray(chiTietRes.data)) items = chiTietRes.data;
            else if (Array.isArray(chiTietRes.data.data)) items = chiTietRes.data.data;
            else if (Array.isArray(chiTietRes.data.$values)) items = chiTietRes.data.$values;
            
            const total = items.reduce((sum, item) => sum + (item.diemSo || item.DiemSo || 0), 0);
            setFormData(prev => ({ ...prev, diemXetTuyen: total }));
        }
    }, [chiTietRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            let res;
            if (formData.id) {
                res = await Put(KETQUATUYENSINH_API.UPDATE_ITEM, formData.id, formData);
            } else {
                res = await Post(KETQUATUYENSINH_API.CREATE_ITEM, null, formData);
            }

            if (res && res.ok) {
                toast.success('Lưu kết quả tuyển sinh thành công!');
                refetch();
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (error) {
            console.error(error);
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Đang tải dữ liệu kết quả...</p>
            </div>
        );
    }

    return (
        <div className="bg-light p-3 rounded border mt-3">
            <h5 className="font-weight-bold text-success mb-4"><i className="fas fa-award mr-2"></i> Quyết định kết quả tuyển sinh</h5>
            
            <Alert variant="info" className="small">
                <i className="fas fa-info-circle mr-1"></i> <strong>Điểm xét tuyển</strong> sẽ được hệ thống tự động tổng hợp từ Bảng chấm điểm đề cương nghiên cứu sau khi bạn lưu.
            </Alert>

            <Row>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Kết quả <span className="text-danger">*</span></Form.Label>
                        <div>
                            {objectKetQuaTuyenSinh.map((item, idx) => (
                                <Form.Check
                                    key={idx}
                                    inline
                                    type="radio"
                                    id={`ketQua_${item.value}`}
                                    label={<span className={`text-${item.color} font-weight-bold`}>{item.label}</span>}
                                    name="ketQua"
                                    value={item.value}
                                    checked={formData.ketQua === item.value}
                                    onChange={(e) => setFormData({ ...formData, ketQua: parseInt(e.target.value) })}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Điểm xét tuyển</Form.Label>
                        <Form.Control 
                            type="text" 
                            disabled 
                            value={formData.diemXetTuyen !== undefined && formData.diemXetTuyen !== null ? formData.diemXetTuyen : 'Chờ cập nhật...'} 
                            className="bg-white font-weight-bold text-danger"
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Số quyết định</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Nhập số quyết định..."
                            value={formData.soQuyetDinh} 
                            onChange={(e) => setFormData({ ...formData, soQuyetDinh: e.target.value })}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Cán bộ hướng dẫn</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Nhập tên cán bộ hướng dẫn..."
                            value={formData.canBoHuongDan} 
                            onChange={(e) => setFormData({ ...formData, canBoHuongDan: e.target.value })}
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold d-block">Thời hạn đào tạo tiêu chuẩn</Form.Label>
                        <div>
                            {objectThoiHanDaoTao.map((item, idx) => (
                                <Form.Check
                                    key={idx}
                                    inline
                                    type="radio"
                                    id={`thoiHanDaoTao_${item.value}`}
                                    label={item.label}
                                    name="thoiHanDaoTao"
                                    value={item.value}
                                    checked={formData.thoiHanDaoTao === item.value}
                                    onChange={(e) => setFormData({ ...formData, thoiHanDaoTao: parseInt(e.target.value) })}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                        <Form.Control 
                            type="date" 
                            value={formData.tuNgay} 
                            onChange={(e) => setFormData({ ...formData, tuNgay: e.target.value })}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                        <Form.Control 
                            type="date" 
                            value={formData.denNgay} 
                            onChange={(e) => setFormData({ ...formData, denNgay: e.target.value })}
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <div className="mt-2">
                        <DocumentInput 
                            labelTitle="File quyết định đính kèm"
                            value={formData.fileQuyetDinh}
                            onChangeProp={(val) => setFormData({ ...formData, fileQuyetDinh: val })}
                        />
                    </div>
                </Col>
            </Row>
            
            <div className="text-right mt-3">
                <Button variant="success" onClick={handleSave} disabled={saving}>
                    {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang lưu...</> : <><i className="fas fa-save mr-2"></i> Lưu kết quả</>}
                </Button>
            </div>
        </div>
    );
};

export default KetQuaTuyenSinhTab;
